import React from "react";
import ReactDOM from "react-dom";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import reportWebVitals from "./reportWebVitals";
import "./assets/styles/index.css";
import App from "./App";

import { Store } from "./store";

ReactDOM.render(
  <React.StrictMode>
    <Store>
      <Router>
        <Switch>
          <Route path="/:lang">
            <App />
          </Route>
          <Route path="">
            <App />
          </Route>
        </Switch>
      </Router>
    </Store>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
